import MainPage from "../../components/main/mainPage";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
const Main = ({ authUser }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const popupIntervalRef = useRef(null);
  const popupTimeoutRef = useRef(null);

  /*const showPopup = () => {
    Swal.fire({
      title: t("popupTitle", "Бажаєте розпочати навчання?"),
      confirmButtonText: t("startLearning", "Розпочати"),
      allowOutsideClick: true,
      allowEscapeKey: true,
      confirmButtonColor: "#621eeb",
    }).then((result) => {
      if (result.isConfirmed) {
        clearInterval(popupIntervalRef.current);
        navigate("/language");
      }
    });
  };

  useEffect(() => {
    const selectedLanguage = localStorage.getItem("selectedLanguage");

    if (!selectedLanguage) {
      popupTimeoutRef.current = setTimeout(() => {
        showPopup();

        popupIntervalRef.current = setInterval(() => {
          showPopup();
        }, 10000);
      }, 5000);
    }

    return () => {
      clearTimeout(popupTimeoutRef.current);
      clearInterval(popupIntervalRef.current);
    };
  }, []);
*/
  return (
    <>
      <MainPage authUser={authUser} />
    </>
  );
};
export default Main;
